// extracted by css-extract-rspack-plugin
export default {"spinner":"iRsnGuveoIoF6MKN__spinner___","header":"i6SwjCjSyHELBpcz__header___","summary":"NeYjkrgolgULb923__summary___"};